import { render, staticRenderFns } from "./SettingLocation.vue?vue&type=template&id=703e8afc&scoped=true&"
import script from "./SettingLocation.vue?vue&type=script&lang=js&"
export * from "./SettingLocation.vue?vue&type=script&lang=js&"
import style0 from "./SettingLocation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SettingLocation.vue?vue&type=style&index=1&id=703e8afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e8afc",
  null
  
)

export default component.exports